import Typography from '@mui/material/Typography';
import AddFinancialUser from '../../containers/add-financial-user';
import BreadcrumbsComponent from '../../components/molecules/Breadcrumbs/Breadcrumbs';
import { Container } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate } from 'react-router-dom';
import { ADVISOR_ROUTES } from '../../routes/routeConstants';

const FinancialAdvisor = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const { state }: any = useLocation();

    const breadcrumbs = [
        <Typography
            key="1"
            variant="body1"
            onClick={() => navigate(ADVISOR_ROUTES.ADMIN)}
            sx={{
                color: 'primary[500]',
                fontSize: '22px',
                cursor: 'pointer',
                '&:hover': {
                    textDecoration: 'underline 1px',
                    textUnderlineOffset: '3px'
                }
            }}
        >
            {t('TEXT_ADMIN_ADD_USER_HEADER')}
        </Typography>,
        <Typography key="2" variant="body1" sx={{ color: 'primary[500]', fontSize: '22px' }}>
            {t('FINANCIAL_ADVISORS_ADD_NEW_USER_HEADER')}
        </Typography>
    ];
    return (
        <Container>
            <BreadcrumbsComponent breadcrumbs={breadcrumbs} />
            <AddFinancialUser
                fromAdvisor={state?.fromAdvisor}
                userRole={state?.userRole}
                userTenant={state?.userTenant}
            />
        </Container>
    );
};

export default FinancialAdvisor;
